module.exports = __webpack_public_path__ + "img/12_klio_21.745d96af.jpg";